import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/public'
  },
  {
    name: 'Demo',
    path: '/public',
    component: () => import('./view/public'),
    meta: {
      title: 'Demo'
    }
  },
  {
    name: 'main',
    path: '/main',
    redirect: "/myClient",
    component: () => import('./view/main'),
    meta: {
      title: '我的客户'
    },
    children: [
      {
        path: '/myClient',
        name: 'myClient',
        component: () => import('./view/client'),
        props: route => ({
          nameLike: route.query.nameLike,
          salesmanId: route.query.salesmanId,
        }),
        meta: {
          title: '我的客户'
        }
      },
      {
        name: 'myTeam',
        path: '/myTeam',
        component: () => import('./view/team'),
        props: route => ({
          teamId: route.query.teamId,
        }),
        meta: {
          title: '我的团队'
        }
      },
      {
        name: 'teamProcess',
        path: '/teamProcess',
        component: () => import('./view/process/team'),
        meta: {
          title: '团队审核'
        }
      },
      {
        name: 'registerProcess',
        path: '/registerProcess',
        component: () => import('./view/process/register'),
        meta: {
          title: '注册审核'
        }
      },
      {
        name: 'remindConfig',
        path: '/remindConfig',
        component: () => import('./view/remind'),
        meta: {
          title: '提醒配置'
        }
      },
      {
        name: 'adminAccount',
        path: '/adminAccount',
        component: () => import('./view/main/Account.vue'),
        meta: { title: '个人中心' }
      }
    ]
  },
  {
    path: '/main/home',
    name: 'mainhome',
    component: () => import('./view/home'),
    meta: {
      title: '首页'
    }
  },
  {
    name: 'enterpriseRegister',
    path: '/enterpriseRegister',
    component: () => import('./view/register/enterprise'),
    meta: {
      title: '企业注册'
    }
  },
  {
    name: 'personRegister',
    path: '/personRegister',
    component: () => import('./view/register/person'),
    props: route => ({
      invitedid: route.query.invitedid,
      isenterprise: route.query.isenterprise,
    }),
    meta: {
      title: '个人注册'
    }
  },
  {
    name: 'teamManage',
    path: '/teamManage',
    component: () => import('./view/team/manage'),
    props: route => ({
      firmId: route.query.firmId,
    }),
    meta: {
      title: '我的团队'
    }
  },
  {
    name: 'teamAssigne',
    path: '/teamAssigne',
    component: () => import('./view/team/assigne'),
    props: route => ({
      userId: route.query.userId,
      firmId: route.query.firmId,
    }),
    meta: {
      title: '分配团队'
    }
  },
  {
    name: 'teamAddMembers',
    path: '/teamAddMembers',
    component: () => import('./view/team/addmembers'),
    props: route => ({
      departmentId: route.query.departmentId,
      firmId: route.query.firmId,
    }),
    meta: {
      title: '添加组员'
    }
  },
  {
    name: 'callbackResult',
    path: '/callbackResult',
    component: () => import('./view/callbackResult'),
    meta: {
      title: '小程序回调页'
    },
    props: route => ({
      msg: route.query.t,
    }),
  },
  {
    name: 'noPermission',
    path: '/noPermission',
    component: () => import('./view/noPermission/index.vue'),
    meta: {
      title: '权限不足'
    }
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./view/login'),
    props(route) {
      return {
        source: route.query.source,
      }
    },
    meta: {
      title: '登录'
    }
  },
  {
    name: 'changePassword',
    path: '/changePassword',
    props(route) {
      return {
        source: route.query.source,
      }
    },
    component: () => import('./view/changePassword'),
    meta: {
      title: '修改密码'
    }
  },
  {
    name: 'enterpriseManage',
    path: '/enterpriseManage',
    component: () => import('./view/enterpriseManage'),
    props: route => ({
      activeTab: route.query.t,
    }),
    meta: {
      title: '企业管理'
    }
  },
  {
    name: 'review',
    path: "/review",
    meta: { title: '企业简易报告' },
    component: () => import('./view/credit/Review.vue'),
    props(route) {
      return {
        id: route.query.id,
      }
    },
  },
  {
    name: 'credit',
    redirect: "/credit/home",
    component: () => import('./view/credit/Layout.vue'),
    props(route) {
      return {
        code: route.query.code,
        state: route.query.state,
      }
    },
    children: [
      {
        name: 'noPermission',
        path: 'noPermission',
        component: () => import('./view/noPermission/index.vue'),
        meta: {
          title: '权限不足'
        }
      },
      {
        name: 'login',
        path: 'login',
        component: () => import('./view/login'),
        props(route) {
          return {
            source: route.query.source,
          }
        },
        meta: {
          title: '登录'
        }
      },
      {
        path: 'home',
        component: () => import('./view/credit/Home.vue'),
        name: 'CreditHome',
        meta: { title: '企业信息' }
      },
      {
        path: 'report',
        component: () => import('./view/credit/Report.vue'),
        name: 'Report',
        meta: { title: '企业简易报告' },
        props(route) {
          return {
            activeTab: parseInt(route.query.t),
            id: route.query.id,
          }
        },
      },
      {
        path: 'account',
        component: () => import('./view/credit/Account.vue'),
        name: 'CreditAccount',
        meta: { title: '个人中心' }
      },
      {
        path: 'pdf',
        component: () => import('./view/credit/ShowPDF.vue'),
        name: 'ShowPDF',
        props(route) {
          return {
            id: route.query.id,
          }
        },
        meta: { title: '查看征信' }
        
      },
      {
        name: 'changePassword',
        path: 'changePassword',
        props(route) {
          return {
            source: route.query.source,
          }
        },
        component: () => import('./view/changePassword'),
        meta: {
          title: '修改密码'
        }
      },
      {
        name: 'enterpriseManage',
        path: 'enterpriseManage',
        component: () => import('./view/enterpriseManage'),
        props: route => ({
          activeTab: route.query.t,
        }),
        meta: {
          title: '企业管理'
        }
      },
      {
        name: 'customerManage',
        path: 'customerManage',
        component: () => import('./view/customer'),
        meta: { title: '贷后管理' },
        props(route) {
          return {
            loanType: parseInt(route.query.loanType),
          }
        },
      },
      {
        name: 'message',
        path: 'message',
        component: () => import('./view/message'),
        meta: { title: '消息管理' }
      }
    ]
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ mode: 'history', routes });

// 捕获 NavigationDuplicated 错误
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
